module.exports = "<div>\r\n    <gw-pl-input-ctrl ng-if=\"isFieldVisible('Name')\" readonly=\"readonly\" model=\"contact.contactName\"\r\n                      label=\"{{'platform.inputs.company-details.Name' | translate }}\"></gw-pl-input-ctrl>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/platform/widgets/inputs/templates/companyname-details-default.html
// module id = 412
// module chunks = 0